import React, { useEffect } from 'react';
import { useFormResponseStore } from '@/store';

interface AddTitleProps {
  question: any;
  sectionId: string;
  sectionName: string;
}

export const AddTitleAnswer: React.FC<AddTitleProps> = ({ question, sectionId, sectionName }) => {
  const { setResponse } = useFormResponseStore();

  useEffect(() => {
    if (question.titleName) {
      setResponse(
        sectionId,
        sectionName,
        question.id,
        question.type,
        question.label || '',
        {
          titleName: question.titleName
        }
      );
    }
  }, [question.id, question.type, question.label, question.titleName, sectionId, sectionName, setResponse]);

  return <h2 className="text-lg mb-4 text-[#001A55] font-medium">{question.titleName}</h2>;
};